import { AdminDocument } from '../types';
import { api } from '../../../../core/utils/apiClient';

export class AdminDocumentsService {
  async getAllDocuments(): Promise<AdminDocument[]> {
    try {
      const response = await api.get('/api/v1/companies/');
      if (response.ok) {
        const companiesData = await response.json();
        const companies = companiesData.companies || [];
        
        const allDocuments: AdminDocument[] = [];
        for (const company of companies) {
          try {
            const docsRes = await api.get(`/api/v1/documents/companies/${company.id}/documents`);
            if (docsRes.ok) {
              const docsData = await docsRes.json();
              const docs = docsData.documents || [];
              allDocuments.push(...docs.map((d: any) => ({ ...d, company_name: company.name })));
            }
          } catch (err) {
            console.error('Error loading docs for company:', company.id);
          }
        }
        
        return allDocuments;
      }
      return [];
    } catch (error) {
      console.error('Error fetching documents:', error);
      return [];
    }
  }

  async getDocumentById(documentId: number): Promise<AdminDocument | null> {
    try {
      const response = await api.get(`/api/v1/documents/documents/${documentId}`);
      if (response.ok) {
        return await response.json();
      }
      return null;
    } catch (error) {
      console.error('Error fetching document:', error);
      return null;
    }
  }

  async deleteDocument(documentId: number): Promise<boolean> {
    try {
      const response = await api.delete(`/api/v1/documents/documents/${documentId}`);
      return response.ok;
    } catch (error) {
      console.error('Error deleting document:', error);
      return false;
    }
  }

  async downloadDocument(documentId: number): Promise<Blob | null> {
    try {
      const response = await api.get(`/api/v1/documents/documents/${documentId}/download`);
      if (response.ok) {
        return await response.blob();
      }
      return null;
    } catch (error) {
      console.error('Error downloading document:', error);
      return null;
    }
  }
}

export const adminDocumentsService = new AdminDocumentsService();
